<template>
    <div class="form-group"
         :class="{
             'horizontal': horizontal,
             'disabled': !!disabled,
         }"
    >
        <label v-if="label"
               :for="labelFor"
               :class="[
                    labelClass,
                    {
                        'm-0 mr-3': horizontal
                    }
               ]"
               v-html="getLabel"
        />
        <slot></slot>
        <form-error v-if="errors"
                    :field="name"
                    :errors="errors"
        />
    </div>
</template>

<script>
import FormError from '../Errors/FormError';
export default {
    name: "form-group",
    components: {
        FormError
    },
    props: {
        name: {
            type: String,
            default: "name"
        },
        label: {
            type: String,
            default: ""
        },
        labelFor: {
            type: String,
            default: ""
        },
        labelClass: {
            type: String,
            default: "form-label"
        },
        errors: {
            default: null
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        requiredText: {
            type: String,
            default: '*'
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        getLabel() {
            return !this.required
                ? this.label
                : `${this.label} <span class="required">${this.requiredText}</span>`;
        },
    },
}
</script>